import {createSlice} from "@reduxjs/toolkit";
import {USCompanyFormDataType} from "@/component/blocks/onboard-blocks/USCompanyForm";
import {UKCompanyFormDataType} from "@/component/blocks/onboard-blocks/UKCompanyForm";
import {UAECompanyFormDataType} from "@/component/blocks/onboard-blocks/UAECompanyForm";
import {BDCompanyFormDataType} from "@/component/blocks/onboard-blocks/BDCompanyForm";
import {Package} from "@/store/api/packageApi";
export interface PackageData {
    id: number;
    name: string;
    status: number;
    sub_summary: string;
    description: string;
    amount: string;
    category: string;
    country_type: string;
    existing_llc: number;
    recommend_state: number;
    sort: number;
}

interface EmailValidationState {
    status: 'pending' | 'valid' | 'existing_user' | 'invalid' | null;
    email: string | null;
}

interface InitialStateData {
    country: number | null;
    packageData: PackageData | null;
    company_email: string | null;
    emailValidation: EmailValidationState;
    businessType: number | null;
    formData: USCompanyFormDataType | UKCompanyFormDataType | UAECompanyFormDataType | BDCompanyFormDataType | null;
    additionalService: Package[];
}

const initialState: InitialStateData = {
    country: null,
    packageData: null,
    company_email: null,
    businessType: null,
    emailValidation: {
        status: null,
        email: null,
    },
    formData: null,
    additionalService: [],

}

const onboardSlice = createSlice({
    name: "onboard",
    initialState,
    reducers: {
        addCountry: (state, action) => {
            state.country = action.payload
        },
        addPackage: (state, action) => {
            state.packageData = action.payload
        },
        addCompanyEmail: (state, action) => {
            state.company_email = action.payload
        },
        addBusinessType: (state, action) => {
            state.businessType = action.payload
        },
        addAdditionalService: (state, action) => {
            state.additionalService = action.payload
        },
        setEmailValidationStatus: (state, action) => {
            state.emailValidation = action.payload
        },
        setFormData: (state, action) => {
            state.formData = action.payload
        },
        clearEmailValidation: (state) => {
            state.emailValidation = {
                status: null,
                email: null,
            }
        }
    }
})

export const {
    addCountry,
    addPackage,
    addCompanyEmail,
    setEmailValidationStatus,
    clearEmailValidation,
    addAdditionalService,
    setFormData,
    addBusinessType
} = onboardSlice.actions;
export default onboardSlice.reducer;